import { render, staticRenderFns } from "./es-conf-form.vue?vue&type=template&id=2c031677&scoped=true&"
import script from "./es-conf-form.vue?vue&type=script&lang=ts&"
export * from "./es-conf-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c031677",
  null
  
)

export default component.exports